import React from 'react';
import PropTypes from 'prop-types';
import withHeadlineProps from './headlineProps';
import './headline.scss';

/**
 * H2 text component
 */

export function H2(props) {
	return (
		<h2 className={props.className}>
			{props.children}
		</h2>
	);
}

H2.propTypes = {
	className: PropTypes.string,
	children: PropTypes.node
};

export default withHeadlineProps(H2);
